/** Federated gateway GraphQL endpoints (experience hockey lives here). */
export const GRAPHQL_GATEWAY_URL = {
  dev: 'https://use1-dev-th-gateway.rbictg.com/graphql',
  staging: 'https://use1-staging-th-gateway.rbictg.com/graphql',
};

/** Legacy campaigns REST (prod until GraphQL cutover is validated). */
export const REST_CAMPAIGNS_URL = {
  dev: 'https://th.campaigns.dev.rbictg.com/v1',
  staging: 'https://th.campaigns.staging.rbictg.com/v1',
  prod: 'https://th.campaigns.rbictg.com/v1',
};

/**
 * Resolve transport for the iframe `env` query param.
 * Staging + dev → GraphQL gateway; everything else stays on REST for now.
 */
export function resolveApiEndpoints(env) {
  if (env === 'dev' || env === 'staging') {
    return {
      useGraphql: true,
      graphqlUrl: GRAPHQL_GATEWAY_URL[env],
      apiUrl: REST_CAMPAIGNS_URL[env],
    };
  }
  return {
    useGraphql: false,
    graphqlUrl: null,
    apiUrl: REST_CAMPAIGNS_URL.prod,
  };
}

const createRoute = (baseUrl) => (proxy, route) => `${baseUrl}/${proxy}/${route}`;

export const getEndpoint = (baseUrl) => {
  const setEndpoint = createRoute(baseUrl);

  return {
    quiz: setEndpoint('user', 'stq'),
    notification: setEndpoint('user', 'preferences'),
    pickHistory: setEndpoint('hockey', 'picks/history'),
    players: setEndpoint('hockey', 'picks'),
    playerPicks: setEndpoint('hockey', 'picks'),
    user: setEndpoint('hockey', 'user'),
    userStats: setEndpoint('hockey', 'user/stats'),
    leaderboard: setEndpoint('hockey', 'contest/challenge/leaderboard'),
    postSeasonLeaderboard: setEndpoint('hockey', 'contest/postseason/leaderboard'),
    seasonLeaderboard: setEndpoint('hockey', 'contest/season/leaderboard'),
    leaderboardLocal: setEndpoint('hockey', 'contest/challenge/leaderboard/local'),
    postSeasonLeaderboardLocal: setEndpoint('hockey', 'contest/postseason/leaderboard/local'),
    seasonLeaderboardLocal: setEndpoint('hockey', 'contest/season/leaderboard/local'),
  };
};
